// import dummy from '../dummyData/dummy.json'
import TokenService from '../services/token-service'
import config from '../config'
const EventService = {
  // see user service for REST API Express function examples
  getAllAlerts(){
    const alertArray = [{"notification":"This is a sample Notification"}]
    return alertArray
    // return fetch(`${config.API_ENDPOINT}/notifications`, {
    //   headers: {
    //     'content-type': 'application/json',
    //     'Authorization': TokenService.getAuthToken()
    //   },
    // }).then((res) =>
    //   !res.ok ? res.json().then((e) => Promise.reject(e)) : res.json()
    // );
  },
  postAlert(alert){
    return fetch(`${config.API_ENDPOINT}/notifications`, {
      method:'POST',
      headers: {
        'content-type': 'application/json',
        'Authorization': TokenService.getAuthToken()
      },
      body:JSON.stringify(alert)
    }).then((res) =>
      !res.ok ? res.json().then((e) => Promise.reject(e)) : res.json()
    );
  }
}

export default EventService;